import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/articles";
import { siteInfo } from "@/mocks/articles";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCategoryOpen, setIsCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    setIsCategoryOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-background-950/95 backdrop-blur-md shadow-lg shadow-black/20"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-fire-fill text-primary-500 text-2xl group-hover:animate-pulse-glow"></i>
            </div>
            <span className="font-heading text-xl font-bold text-foreground-50 tracking-wider">
              {siteInfo.name}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === "/"
                  ? "text-primary-500"
                  : "text-foreground-300 hover:text-primary-400"
              }`}
            >
              首页
            </Link>

            <div className="relative">
              <button
                onClick={() => setIsCategoryOpen(!isCategoryOpen)}
                className={`flex items-center gap-1 text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  location.pathname.startsWith("/category")
                    ? "text-primary-500"
                    : "text-foreground-300 hover:text-primary-400"
                }`}
              >
                分类浏览
                <i
                  className={`ri-arrow-down-s-line text-base transition-transform duration-200 ${
                    isCategoryOpen ? "rotate-180" : ""
                  }`}
                ></i>
              </button>

              {isCategoryOpen && (
                <div className="absolute top-full mt-2 left-1/2 -translate-x-1/2 w-48 bg-background-900 border border-background-700 rounded-lg shadow-xl shadow-black/40 py-2 animate-fade-in">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-300 hover:text-primary-400 hover:bg-background-800 transition-colors duration-150"
                    >
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className={`${cat.icon} text-primary-500`}></i>
                      </div>
                      {cat.name}
                      <span className="ml-auto text-xs text-foreground-600">
                        {cat.count}
                      </span>
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === "/about"
                  ? "text-primary-500"
                  : "text-foreground-300 hover:text-primary-400"
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="flex items-center gap-1.5 px-4 py-2 bg-primary-500 hover:bg-primary-600 text-foreground-50 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-download-line"></i>
              </div>
              APP下载
            </button>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden flex items-center justify-center w-10 h-10 text-foreground-300 cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i
                className={`text-xl ${
                  isMobileMenuOpen ? "ri-close-line" : "ri-menu-line"
                }`}
              ></i>
            </div>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-900/98 backdrop-blur-md border-t border-background-700 animate-fade-in">
          <div className="px-4 py-4 flex flex-col gap-2">
            <Link
              to="/"
              className={`px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                location.pathname === "/"
                  ? "text-primary-500 bg-background-800"
                  : "text-foreground-300 hover:text-foreground-100 hover:bg-background-800"
              }`}
            >
              首页
            </Link>
            <div className="text-sm font-medium text-foreground-400 px-3 py-2">
              分类浏览
            </div>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`flex items-center gap-3 px-5 py-2 rounded-lg text-sm transition-colors ${
                  location.pathname === `/category/${cat.slug}`
                    ? "text-primary-500 bg-background-800"
                    : "text-foreground-300 hover:text-foreground-100 hover:bg-background-800"
                }`}
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${cat.icon} text-primary-500`}></i>
                </div>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                location.pathname === "/about"
                  ? "text-primary-500 bg-background-800"
                  : "text-foreground-300 hover:text-foreground-100 hover:bg-background-800"
              }`}
            >
              关于我们
            </Link>
            <button className="flex items-center justify-center gap-1.5 mt-2 px-4 py-2.5 bg-primary-500 hover:bg-primary-600 text-foreground-50 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-download-line"></i>
              </div>
              APP下载
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}